/**
 * @file util.ts
 * Utils of Integration Runtime
 */
import { irTypesConst, irCreateType } from './integrationruntime.constants';
import {
    IntegrationRuntime,
    AirflowIntegrationRuntime,
    ManagedIntegrationRuntime,
    SelfHostedIntegrationRuntime
} from '../model/integrationRuntime';
import { stringIsNullOrEmpty } from '../shared/utils/string.util';

// eslint-disable-next-line @typescript-eslint/naming-convention
export function GetIRTypeFromLocalModel(irModel: IntegrationRuntime): irCreateType {
    if (irModel instanceof AirflowIntegrationRuntime) {
        return irTypesConst.Airflow;
    }

    if (irModel instanceof ManagedIntegrationRuntime) {
        if (!stringIsNullOrEmpty(irModel.sharedIROrigianlResourceId)) {
            return irTypesConst.AzureSSISLinked;
        }
        if (!stringIsNullOrEmpty(irModel.ssisCatalogServerEndpoint) || irModel.useSSISDB === false) {
            return irTypesConst.AzureSSIS;
        } else if (irModel.managedVirtualNetwork) {
            return irTypesConst.ManagedVNet;
        } else {
            return irTypesConst.Azure;
        }
    }

    if (irModel instanceof SelfHostedIntegrationRuntime) {
        if (irModel.sharedIROriginalResourceId != null) {
            return irTypesConst.Linked;
        } else if (irModel.subType === irTypesConst.Emulator) {
            return irTypesConst.Emulator;
        } else {
            return irTypesConst.SelfHosted;
        }
    }

    return undefined;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export function GetIRSubTypeFromLocalModel(irModel: IntegrationRuntime): irCreateType {
    if (irModel instanceof ManagedIntegrationRuntime) {
        if (irModel.sharingDataFactories != null && irModel.sharingDataFactories.length > 0 || irModel.useSharingSsisIr) {
            return irTypesConst.AzureSSISShared;
        } else if (irModel.sharedIROrigianlResourceId != null) {
            return irTypesConst.AzureSSISLinked;
        }
    }
    return undefined;
}
